export const addPlayBtnListeners = (emblaApi, playBtn) => {
    // Intern state for playing status
    let isPlaying = true  // Siden autoplay starter med playOnInit: true

    const togglePlayBtnState = () => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const iconContent = playBtn.querySelector('span');
        const playText = playBtn.dataset.playText;
        const pauseText = playBtn.dataset.pauseText;

        if (isPlaying) {
            iconContent.classList.remove('icon-play');
            iconContent.classList.add('icon-pause');
            playBtn.setAttribute('aria-label', pauseText);
        } else {
            iconContent.classList.remove('icon-pause');
            iconContent.classList.add('icon-play');
            playBtn.setAttribute('aria-label', playText);
        }
    }

    const onPlayBtnClick = (event) => {
        event.stopPropagation()

        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        isPlaying = !isPlaying // Toggle intern state

        if (isPlaying) {
            autoplay.play()
        } else {
            autoplay.stop()
        }

        togglePlayBtnState()
    }

    playBtn.addEventListener('click', onPlayBtnClick)
    emblaApi.on('autoplay:timerstopped', () => {
        isPlaying = false
        togglePlayBtnState()
    });
    
    togglePlayBtnState()

    return () => {
        playBtn.removeEventListener('click', onPlayBtnClick)
    }
}

export const addNavBtnListeners = (emblaApi, ...navButtons) => {
    // Flatten the array first and then filter out null/undefined
    navButtons = navButtons
        .flat()
        .filter((navButton) => navButton);
    
    const onNavClick = () => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }

    navButtons.forEach((navButton) =>
        navButton.addEventListener('click', onNavClick, true)
    )

    return () => {
        navButtons.forEach((navButton) =>
            navButton.removeEventListener('click', onNavClick, true)
        )
    }
}